import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import useSelectedStore from "../../hooks/useSelectedStore";
import useLogoFevIcon from "../../hooks/useLogoFevIcon";

const SomethingWrong = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fevicon } = useLogoFevIcon();
  const { selectedStore } = useSelectedStore();

  useEffect(() => {
    const link: HTMLLinkElement =
      document.querySelector("link[rel='icon']") ||
      document.createElement("link");

    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = fevicon;
    document.head.appendChild(link);
  }, [selectedStore, fevicon]);

  return (
    <div className="pageNotFOund">
      <div className="iconBlock">
        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
      </div>

      {/* UPDATED TEXT */}
      <h2 className="mt-2 mb-2">{t("SomethingWrong.title", "Something went wrong")}</h2>
      <p className="mb-2">{t("SomethingWrong.message", "Please try again later.")}</p>

      <div
        onClick={() => navigate("/")}
        className="btn btnBluewentwrong NotFound text-white bgBlue font-medium rounded-[7px] text-center inline-flex items-center justify-center cursor-pointer "
      >
        {t("SomethingWrong.goBack", "Go back to Home")}
      </div>
    </div>
  );
};

export default SomethingWrong;
